/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Sub_Sport_TreadmillInputs */

const en_ui_sub_sport_treadmill = /** @type {(inputs: Ui_Sub_Sport_TreadmillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treadmill`)
};

const de_ui_sub_sport_treadmill = /** @type {(inputs: Ui_Sub_Sport_TreadmillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laufband`)
};

/**
* | output |
* | --- |
* | "Treadmill" |
*
* @param {Ui_Sub_Sport_TreadmillInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_sub_sport_treadmill = /** @type {((inputs?: Ui_Sub_Sport_TreadmillInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Sub_Sport_TreadmillInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_sub_sport_treadmill(inputs)
	return de_ui_sub_sport_treadmill(inputs)
});